import ContatoMotivoService from "../../services/ContatoMotivoService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormContatoMotivo from "../../pages/ContatoMotivo/FormContatoMotivo";
import Permissao from "../../controllers/Permissao";

export default class SelectContatoMotivoByContatoStatus extends FormSelectSearchModal {

    constructor(props) {
        super(props);

        this.getOptions = this.getOptions.bind(this);
        this.receivEventDispach = this.receivEventDispach.bind(this);
        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(74));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);

        this.state.formNewConfig = {
            title: 'Cadastro de Contato Motivo',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormContatoMotivo,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idContatoMotivo) {
                        this.handleSetValue(response.data?.idContatoMotivo);
                        this.setState({ value: response.data.idContatoMotivo }, () => {
                            this.handleOpenSearch();
                        });
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    }

    componentDidUpdate(nextProps) {
        super.componentDidUpdate(nextProps);
        if (nextProps.idContatoStatus !== this.props.idContatoStatus) {
            this.getOptions();
        }
    }

    componentDidMount() {

        super.componentDidMount();

        this.getOptions();

        if (this.dispachChangeDidMount && this.props.value) {
            this.handleChange({ target: { value: this.props.value, name: this.props.name } });
        }

        this.state.headers = [
            { key: "value", label: "Código", className: 'text-center d-none d-md-table-cell' },
            { key: "label", label: "Nome do Motivo" },            
        ];
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de ContatoMotivo',
            sizeModal: 'modal-xl',
            config: {
                isModal: true,
                idContatoStatus: this.props.idContatoStatus
            },
            form: FormContatoMotivo,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idContatoMotivo) {
                        this.handleOpenSearch(null, response.data?.idContatoMotivo);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };


    /*receivEventDispach(event, data) {
        this.state.idContatoStatus = data.idContatoStatus;
        this.getOptions();
    }*/

    getOptions(callBack) {
        var ativo = this.props.ativo === undefined ? null : this.props.ativo;

        if (this.props.idContatoStatus) {
            ContatoMotivoService.getForComboByContatoStatus(this.props.idContatoStatus, ativo, (response) => {
                this.setState({ options: response }, () => {
                    if (callBack) {
                        callBack();
                    }
                });
            });
        } else {
            this.setState({ options: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }

    render() {
        return super.render();
    }
}